import Main from './Main.vue'
import Inadimplentes from './components/Inadimplentes'
// import VisualizarArrematante from './components/VisualizarArrematante'
// import Arrematante from './components/Arrematante'

export default [{
  path: 'inadimplentes',
  name: 'inadimplentes',
  component: Main,
  children: [
    {path: '/', component: Inadimplentes, name: 'inadimplentes'}
    // {path: ':id', component: VisualizarArrematante, name: 'inadimplentes.visualizar'}
  ]
}
]



// WEBPACK FOOTER //
// ./src/app/website/inadimplentes/routes.js